import React, { useState } from 'react';

const LISTS = [
  { id:1, name:'All Clubs',            type:'Active',  contacts:3527, criteria:'transferexpo_contact_type = Club',                      created:'Jan 15, 2026', updated:'Apr 3, 2026'  },
  { id:2, name:'All Scouts',           type:'Active',  contacts:1632, criteria:'transferexpo_contact_type = Scout',                     created:'Jan 15, 2026', updated:'Apr 3, 2026'  },
  { id:3, name:'Activated Clubs',      type:'Active',  contacts:27,   criteria:'activation_status = Activated AND type = Club',         created:'Feb 1, 2026',  updated:'Apr 3, 2026'  },
  { id:4, name:'Scouts — No eval yet', type:'Active',  contacts:94,   criteria:'evaluations = 0 AND type = Scout',                     created:'Feb 1, 2026',  updated:'Apr 1, 2026'  },
  { id:5, name:'Active Scouts',        type:'Active',  contacts:80,   criteria:'evaluations > 0 AND status = Active',                  created:'Feb 10, 2026', updated:'Apr 3, 2026'  },
  { id:6, name:'Inactive 30d+',        type:'Active',  contacts:312,  criteria:'last_activity < 30 days ago',                          created:'Mar 1, 2026',  updated:'Apr 1, 2026'  },
  { id:7, name:'Premium tier',         type:'Active',  contacts:120,  criteria:'evaluation_tier = Premium',                            created:'Mar 10, 2026', updated:'Apr 2, 2026'  },
  { id:8, name:'UK Clubs',             type:'Static',  contacts:2,    criteria:'country = United Kingdom AND type = Club',             created:'Mar 15, 2026', updated:'Mar 15, 2026' },
  { id:9, name:'Unengaged Scouts',     type:'Active',  contacts:44,   criteria:'type = Scout AND last_activity > 14 days AND evals = 0',created:'Apr 1, 2026',  updated:'Apr 3, 2026'  },
];

const FILTER_PROPERTIES = ['Contact type', 'Status', 'Country', 'Activation status', 'Evaluations', 'Last activity', 'Plan', 'Region'];
const FILTER_OPERATORS  = ['is equal to', 'is not equal to', 'greater than', 'less than', 'is known', 'is unknown', 'contains'];

const typeBadge = t => t === 'Active' ? 'badge badge-green' : 'badge badge-gray';

export default function Lists({ toast }) {
  const [lists, setLists]       = useState(LISTS);
  const [search, setSearch]     = useState('');
  const [creating, setCreating] = useState(false);
  const [newList, setNewList]   = useState({ name:'', type:'Active', filters:[{ property:'Contact type', operator:'is equal to', value:'' }] });

  const filtered = lists.filter(l => !search || l.name.toLowerCase().includes(search.toLowerCase()));

  const addFilter = () => setNewList(prev => ({ ...prev, filters: [...prev.filters, { property:'Contact type', operator:'is equal to', value:'' }] }));
  const removeFilter = i => setNewList(prev => ({ ...prev, filters: prev.filters.filter((_,idx) => idx !== i) }));
  const updateFilter = (i, key, val) => setNewList(prev => ({
    ...prev, filters: prev.filters.map((f,idx) => idx===i ? {...f,[key]:val} : f)
  }));

  const createList = () => {
    if (!newList.name) { toast?.('Enter a list name', 'warning'); return; }
    const criteria = newList.filters.map(f => `${f.property} ${f.operator} ${f.value}`).join(' AND ');
    const l = { id: Date.now(), name: newList.name, type: newList.type, contacts: Math.floor(Math.random()*500+10), criteria, created: new Date().toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}), updated: new Date().toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}) };
    setLists(prev => [l, ...prev]);
    setCreating(false);
    setNewList({ name:'', type:'Active', filters:[{ property:'Contact type', operator:'is equal to', value:'' }] });
    toast?.('List created successfully');
  };

  return (
    <div>
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Total lists</div><div className="stat-value">{lists.length}</div><div className="stat-sub">Segments</div></div>
        <div className="stat-card"><div className="stat-label">Active lists</div><div className="stat-value">{lists.filter(l=>l.type==='Active').length}</div><div className="stat-sub stat-up">Auto-updating</div></div>
        <div className="stat-card"><div className="stat-label">Total contacts</div><div className="stat-value">{lists.reduce((s,l)=>s+l.contacts,0).toLocaleString()}</div><div className="stat-sub">Across all lists</div></div>
        <div className="stat-card"><div className="stat-label">Static lists</div><div className="stat-value">{lists.filter(l=>l.type==='Static').length}</div><div className="stat-sub">Manual</div></div>
      </div>

      <div className="toolbar">
        <input className="search-input" placeholder="Search lists..." value={search} onChange={e => setSearch(e.target.value)} />
        <button className="btn btn-primary" onClick={() => setCreating(true)}>+ Create list</button>
      </div>

      {creating && (
        <div className="card" style={{ marginBottom:16 }}>
          <div className="card-header">
            <span className="card-title">Create contact list</span>
            <button className="btn btn-ghost" style={{ fontSize:12 }} onClick={() => setCreating(false)}>✕</button>
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
            <div style={{ display:'grid', gridTemplateColumns:'1fr auto', gap:14 }}>
              <div>
                <label style={{ fontSize:11, color:'var(--text-muted)', fontFamily:'var(--font-ui)', textTransform:'uppercase', letterSpacing:'0.5px', display:'block', marginBottom:6 }}>List name *</label>
                <input className="search-input" placeholder="e.g. Active UK Clubs" value={newList.name} onChange={e => setNewList(p=>({...p,name:e.target.value}))} />
              </div>
              <div>
                <label style={{ fontSize:11, color:'var(--text-muted)', fontFamily:'var(--font-ui)', textTransform:'uppercase', letterSpacing:'0.5px', display:'block', marginBottom:6 }}>List type</label>
                <select className="search-input" value={newList.type} onChange={e => setNewList(p=>({...p,type:e.target.value}))}>
                  <option>Active</option>
                  <option>Static</option>
                </select>
              </div>
            </div>

            <div>
              <label style={{ fontSize:11, color:'var(--text-muted)', fontFamily:'var(--font-ui)', textTransform:'uppercase', letterSpacing:'0.5px', display:'block', marginBottom:10 }}>Filter criteria</label>
              {newList.filters.map((f, i) => (
                <div key={i} style={{ display:'flex', gap:8, marginBottom:8, alignItems:'center' }}>
                  {i > 0 && <span style={{ fontSize:11, color:'var(--text-dim)', minWidth:30 }}>AND</span>}
                  <select className="search-input" value={f.property} onChange={e => updateFilter(i,'property',e.target.value)} style={{ flex:1 }}>
                    {FILTER_PROPERTIES.map(p => <option key={p}>{p}</option>)}
                  </select>
                  <select className="search-input" value={f.operator} onChange={e => updateFilter(i,'operator',e.target.value)} style={{ flex:1 }}>
                    {FILTER_OPERATORS.map(o => <option key={o}>{o}</option>)}
                  </select>
                  <input className="search-input" placeholder="Value..." value={f.value} onChange={e => updateFilter(i,'value',e.target.value)} style={{ flex:1 }} />
                  {i > 0 && <button style={{ background:'none', border:'none', color:'var(--text-dim)', cursor:'pointer', fontSize:16, padding:'0 4px' }} onClick={() => removeFilter(i)}>×</button>}
                </div>
              ))}
              <button className="btn btn-ghost" style={{ fontSize:12, marginTop:4 }} onClick={addFilter}>+ Add filter</button>
            </div>

            <div style={{ display:'flex', gap:8 }}>
              <button className="btn btn-primary" onClick={createList}>Create list</button>
              <button className="btn btn-ghost" onClick={() => setCreating(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      <div className="card" style={{ padding:0 }}>
        <div className="card-header" style={{ padding:'16px 20px', borderBottom:'1px solid var(--border)' }}>
          <span className="card-title">All lists</span>
          <span style={{ fontSize:12, color:'var(--text-dim)' }}>{filtered.length} lists</span>
        </div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr><th>List name</th><th>Type</th><th>Contacts</th><th>Criteria</th><th>Updated</th><th>Action</th></tr>
            </thead>
            <tbody>
              {filtered.map(l => (
                <tr key={l.id}>
                  <td style={{ fontWeight:500 }}>{l.name}</td>
                  <td><span className={typeBadge(l.type)}>{l.type}</span></td>
                  <td><strong style={{ color:'var(--accent)' }}>{l.contacts.toLocaleString()}</strong></td>
                  <td style={{ color:'var(--text-muted)', fontSize:11, maxWidth:280 }}><code>{l.criteria}</code></td>
                  <td style={{ color:'var(--text-dim)', fontSize:12 }}>{l.updated}</td>
                  <td style={{ display:'flex', gap:4 }}>
                    <button className="btn btn-ghost" style={{ fontSize:11, padding:'4px 10px' }} onClick={() => toast?.('Sending to this list...')}>Email list</button>
                    <button className="btn btn-ghost" style={{ fontSize:11, padding:'4px 10px' }}>View</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
